<template>
  <!-- Odstranit velikost -->
  <svg
    height="70"
    viewBox="0 0 63 70"
    width="63"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="m62.222 35c0 19.33-15.688 35-35.039 35-10.972 0-20.762-5.036-27.183-12.917a30.492 30.492 0 0 0 7.812 1.011c16.857 0 30.526-13.654 30.526-30.492 0-11.847-6.766-22.122-16.641-27.171a34.526 34.526 0 0 1 5.486-.431c19.35 0 35.04 15.67 35.04 35"
        fill="#4f2b1b"
      />
      <path
        d="m9.82 41.56c2.693 0 4.873-.78 6.54-2.34s2.5-3.593 2.5-6.1c0-3.68-1.827-5.987-5.48-6.92 3.12-1.04 4.68-3.08 4.68-6.12 0-2.187-.713-3.953-2.14-5.3s-3.34-2.02-5.74-2.02c-2.533 0-4.52.72-5.96 2.16s-2.16 3.427-2.16 5.96h4.68c.24-2.64 1.253-3.96 3.04-3.96 1.76 0 2.64 1.053 2.64 3.16 0 2.56-1.507 3.84-4.52 3.84v4.32c3.253 0 4.88 1.453 4.88 4.36 0 1.333-.3 2.38-.9 3.14s-1.433 1.14-2.5 1.14c-2.347 0-3.52-1.747-3.52-5.24h-4.96v.76c0 2.96.773 5.227 2.32 6.8s3.747 2.36 6.6 2.36z"
        fill="#ee9f3f"
        fill-rule="nonzero"
      />
    </g>
  </svg>
</template>
